export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8569.32d7b50b.jpg";